/* eslint-disable */
export default {
  log: 'Lijst',
} as const;

// @key: @#@"log"@#@ @source: @#@"Log"@#@
